import React, { Component } from 'react';
// import {Link} from 'react-router-dom';
import { Button, message, Icon, Card, Breadcrumb, Divider, Table, DatePicker, Empty, Row, Col, List, Typography, Input, Select, Pagination, Anchor } from 'antd';
import moment from 'moment';
import echarts from 'echarts';
import { getStEqInfo, getStEqTop, getStEqAppointOut, getEqUseListCount, getStEqAppointTop, getStEqUseTimeTop, getStEqUseInfoTop, getStEqBadInfoTop, getStUserCreditInfo, getStPiCreditInfo, getUsingPrince, getStRepairInfo, getEqAppointList, getPiListlab, getPiEqInfo } from '@/api/api';
import utils from '@/api/util';
import ExportJsonExcel from 'js-export-excel';
import styles from './statistical.module.css';

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
const { Text, Title } = Typography;
const { Link } = Anchor;

const dateFormat = 'YYYY-MM-DD';
let eqInfo_cavans, eqAppoint_cavans, eqUse_cavans, repairInfo_cavans;

class Statistic extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            selectData: [],//复选框数据的数组
            selectedRowKeys: [],
            selectData3: [],//复选框数据的数组 type=3
            selectedRowKeys3: [],
            eqUseListCount: [],
            eqList: [],
            eqId: '',
            getNum: 10,
            pageNo: 1,
            eqEchartsFlag: true,
            repairEchartsFlag: true,
            eqAppointEchartsFlag: true,
            eqUseEchartsFlag: true,
            piCreditList: [],
            nUsereqList: [],
            wUsereqList: [],
            usingPrinceList: [],
            personTypeName: '',
            piName: '',
            workplace: '',
            personName: '',
            PiCredit_loading: false,
            nUsereq_loading: false,
            wUsereq_loading: false,
            eqTop: [
                //     {
                //     title: '预约次数前十设备',
                //     list: []
                // }, 
                // {
                //     title: '使用次数前十设备',
                //     list: []
                // }, {
                //     title: '使用时长前十设备',
                //     list: []
                // }
            ],
            useTop: [{
                title: '外部人员预约次数前十',
                list: []
            }, {
                title: '内部人员预约次数前十',
                list: []
            }
            ],
            userUseTop: [],
            eqTimestr: '0',
            eqBadTop: [{
                title: '设备平均故障率',
                per: 0
            }, {
                title: '设备最高故障率',
                list: []
            }, {
                title: '设备最低故障率',
                list: []
            }],
            userCreditTop: [{
                per: 0,
                title: '平均信用分',
            }, {
                list: [],
                title: '最高信用分',
            }, {
                list: [],
                title: '最低信用分',
            }],
            PiCredit_pagination: {
                pageSize: 10,
                hideOnSinglePage: true,
            },
            nUsereq_pagination: {
                pageSize: 10,
                hideOnSinglePage: true,
            },
            wUsereq_pagination: {
                pageSize: 10,
                hideOnSinglePage: true,
            },
            eqInfoeqId: '',
            eqInfopiId: '',
            piList: []
        };
        this.setValue = this.setValue.bind(this);
        this.getEqInfo = this.getEqInfo.bind(this);
        this.eqInfoEcharts = this.eqInfoEcharts.bind(this);
        this.getRepairInfo = this.getRepairInfo.bind(this);
        this.repairInfoEcharts = this.repairInfoEcharts.bind(this);
        this.getEqUserAppoint = this.getEqUserAppoint.bind(this);
        this.eqUserAppointEcharts = this.eqUserAppointEcharts.bind(this);
        // this.getEqUseInfo = this.getEqUseInfo.bind(this);
        this.eqUseInfoEcharts = this.eqUseInfoEcharts.bind(this);
        this.getStEqTop = this.getStEqTop.bind(this);
        this.getStEqAppointTop = this.getStEqAppointTop.bind(this);
        this.getStEqUseTimeTop = this.getStEqUseTimeTop.bind(this);
        this.getEqBadInfoTop = this.getEqBadInfoTop.bind(this);
        this.getUsingPrince = this.getUsingPrince.bind(this);
        this.changeNum = this.changeNum.bind(this);
        this.changePageSize = this.changePageSize.bind(this);
        this.getEqList = this.getEqList.bind(this);
        this.getPiList = this.getPiList.bind(this);
        this.storeEqSelect = this.storeEqSelect.bind(this);
        this.eqInfopiIdSelect = this.eqInfopiIdSelect.bind(this);
        this.eqInfoeqIdSelect = this.eqInfoeqIdSelect.bind(this);
        // this.downloadsbExcel = this.downloadsbExcel.bind(this)
        this.getEqUseListCount = this.getEqUseListCount.bind(this)
    }

    componentDidMount() {
        this.getEqInfo();
        this.getRepairInfo();
        this.getEqUserAppoint();
        this.getStEqUseTimeTop();
        // this.getEqUseInfo();
        this.getEqBadInfoTop();
        this.getUserCreditInfo();
        this.getPiCreditInfo()
        this.getEqList()
        this.getPiList()
        this.getEqUseListCount()
    }

    getEqUseListCount() {
        const that = this;
        let params = {};
        if (that.eqUseDateTimeRange && that.eqUseDateTimeRange.length > 0) {
            params = {
                beginTimeString: that.eqUseDateTimeRange ? that.eqUseDateTimeRange[0].format(dateFormat) : '',
                endTimeString: that.eqUseDateTimeRange ? that.eqUseDateTimeRange[1].format(dateFormat) : ''
            };
        }
        getEqUseListCount({ ...params }, res => {
            if (res.statusCode !== 1000) {
                return
            };
            console.log(res);
            that.setState({
                eqUseListPage: 1,
                eqUseListCount: res.list || [],
            });
        }, err => {
            console.log(err)
        })
    }


    getEqList() {
        const that = this;
        getEqAppointList({}, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                eqList: res.eqList
            });
        }, err => {
            console.log(err)
        })
    }
    getPiList() {
        const that = this;
        getPiListlab({}, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                piList: res.list
            });
        }, err => {
            console.log(err)
        })
    }
    storeEqSelect(value) {
        const that = this;
        console.log(value)
        that.setState({
            eqId: value
        });
    }
    eqInfoeqIdSelect(value) {
        const that = this;
        console.log(value)
        that.setState({
            eqInfoeqId: value
        });
    }
    eqInfopiIdSelect(value) {
        const that = this;
        console.log(value)
        that.setState({
            eqInfopiId: value
        });
    }

    // 最近一周设备预约及使用次数
    getEqInfo() {
        const that = this;
        //console.log(that.eqInfoDateRange);
        let params = {
            piId: that.state.eqInfopiId ? that.state.eqInfopiId : '',
            eqId: that.state.eqInfoeqId ? that.state.eqInfoeqId : ''
        };
        if (that.eqInfoDateRange && that.eqInfoDateRange.length > 0) {
            params = Object.assign({}, params, {
                beginTimeString: that.eqInfoDateRange ? that.eqInfoDateRange[0].format(dateFormat) : '',
                endTimeString: that.eqInfoDateRange ? that.eqInfoDateRange[1].format(dateFormat) : ''
            })
        }

        console.log(params)
        // that.eqInfoEcharts()
        // getStEqInfo(params,res=>{
        getPiEqInfo(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                that.setValue('eqEchartsFlag', true);
                that.getStEqTop(params);
                // if(!eqInfo_cavans){
                eqInfo_cavans = echarts.init(document.getElementById('eqInfo'));
                // };
                that.eqInfoEcharts(res)
            } else {
                that.setValue('eqEchartsFlag', false)
                eqEchartsFlag = false
            }
        }, err => {
            console.log(err)
            that.setValue('eqEchartsFlag', false)
        })
    }

    // 课题组设备预约使用时间和次数
    eqInfoEcharts(values) {
        const that = this;
        eqInfo_cavans.clear();
        eqInfo_cavans.showLoading();
        eqInfo_cavans.setOption({
            title: {
                // text: '课题组设备预约使用时间和次数统计',
                // subtext: ''
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: ['时长(小时)', '次数']
            },
            toolbox: {
                show: true,
                feature: {
                    dataView: {
                        show: true,
                        readOnly: false,
                        optionToContent: function (opt) {
                            var axisData = opt.xAxis[0].data;
                            var series = opt.series;
                            var table = '<table class="layui-table" style="width:60%;text-align:center"><tbody><tr>'
                                + '<td>课题组</td>'
                                + '<td>' + series[0].name + '</td>'
                                + '<td>' + series[1].name + '</td>'
                                + '</tr>';
                            for (var i = 0, l = axisData.length; i < l; i++) {
                                table += '<tr>'
                                    + '<td>' + axisData[i] + '</td>'
                                    + '<td>' + series[0].data[i] + '</td>'
                                    + '<td>' + series[1].data[i] + '</td>'
                                    + '</tr>';
                            }
                            table += '</tbody></table>';
                            return table;
                        }
                    },
                    magicType: { show: true, type: ['line', 'bar'] },
                    // restore: {show: true},
                    saveAsImage: { show: true }
                }
            },
            grid: {
                bottom: 90
            },
            calculable: true,
            xAxis: [
                {
                    type: 'category',
                    data: values.pi,
                    axisLabel: {
                        rotate: 30,
                        fontSize: 8
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    axisLabel: {
                        formatter: function (value) {
                            return value;
                        }
                    }

                }
            ],
            dataZoom: [
                {
                    show: true,
                    realtime: true,
                    start: 0,
                    end: 50,
                    dataBackground: {
                        shadowOffsetY: 1000
                    }
                },
                {
                    type: 'inside',
                    realtime: true,
                    start: 0,
                    end: 50,
                    dataBackground: {
                        shadowOffsetY: 1000
                    }
                }
            ],
            series: [
                {
                    name: '时长(小时)',
                    barMaxWidth: '15%',
                    type: 'bar',
                    data: values.times,
                    markPoint: {
                        data:
                            values.times.map(
                                (e, index) => ({ value: e.replace('.00', ''), xAxis: index, yAxis: e.replace('.00', '') })
                            ).filter((item) => item.value > 0)
                    },
                    markLine: {
                        data: [
                            { type: 'average', name: '平均值' }
                        ]
                    }
                },
                {
                    name: '次数',
                    barMaxWidth: '15%',
                    type: 'bar',
                    data: values.num,
                    markPoint: {
                        data: values.num.map(
                            (e, index) => ({ value: e, xAxis: index, yAxis: e })).filter((item) => item.value > 0)
                    },
                    markLine: {
                        data: [
                            { type: 'average', name: '平均值' }
                        ]
                    }
                }
            ]
        });
        eqInfo_cavans.hideLoading()
    }


    // 设备预约及使用次数图表
    eqInfoEcharts00(values) {
        const that = this;
        eqInfo_cavans.clear();
        eqInfo_cavans.showLoading();
        eqInfo_cavans.setOption({
            title: {
                text: (values.beginTimeString && values.endTimeString) ? '' + values.beginTimeString + ' ~ ' + values.endTimeString + '设备预约及使用次数' : '最近一周设备预约及使用次数',
                bottom: 0,
                left: 'center',
                textStyle: {
                    color: '#666',
                    fontSize: 13
                }
            },
            grid: {
                left: '16%',
                right: '16%',
                bottom: 40,
                containLabel: true
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: '{b0}: {c0}次'
            },
            xAxis: {
                type: 'category',
                data: ['设备预约数', '设备使用数']
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: [values.beNum, values.useNum],
                type: 'bar',
                barWidth: '64',
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
            }]
        });
        eqInfo_cavans.hideLoading()
    }

    // 最近一周设备故障申请和确认次数
    getRepairInfo() {
        const that = this;
        let params = {};
        if (that.repairInfoDateRange && that.repairInfoDateRange.length > 0) {
            params = {
                beginTimeString: that.repairInfoDateRange ? that.repairInfoDateRange[0].format(dateFormat) : '',
                endTimeString: that.repairInfoDateRange ? that.repairInfoDateRange[1].format(dateFormat) : ''
            };
        }
        console.log(params)
        // that.eqInfoEcharts()
        getStRepairInfo(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                that.setValue('repairEchartsFlag', true);
                // if(!eqInfo_cavans){
                repairInfo_cavans = echarts.init(document.getElementById('repairInfo'));
                // };
                that.repairInfoEcharts(res)
            } else {
                that.setValue('repairEchartsFlag', false)
                repairEchartsFlag = false
            }
        }, err => {
            console.log(err)
            that.setValue('repairEchartsFlag', false)
        })
    }

    // 设备故障申请和确认次数图表
    repairInfoEcharts(values) {
        const that = this;
        repairInfo_cavans.clear();
        repairInfo_cavans.showLoading();
        repairInfo_cavans.setOption({
            title: {
                text: (values.beginTimeString && values.endTimeString) ? '' + values.beginTimeString + ' ~ ' + values.endTimeString + '设备故障申请及确认次数' : '最近一周设备故障申请及确认次数',
                bottom: 0,
                left: 'center',
                textStyle: {
                    color: '#666',
                    fontSize: 13
                }
            },
            grid: {
                left: '16%',
                right: '16%',
                bottom: 40,
                containLabel: true
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: '{b0}: {c0}次'
            },
            xAxis: {
                type: 'category',
                data: ['故障申请数', '故障确认数']
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: [values.data.applyCount, values.data.affirmCount],
                type: 'bar',
                barWidth: '64',
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
            }]
        });
        repairInfo_cavans.hideLoading()
    }

    // 设备预约及使用次数前十明细
    getStEqTop(params) {
        const that = this;
        let eqTop = this.state.eqTop;
        getStEqTop(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {//修改时 记得切换下面的数组
                // eqTop[0].list = res.beList ? res.beList : [];
                eqTop[0].list = res.useList ? res.useList : [];
                eqTop[1].list = res.useTimeList || []
                that.setValue('eqTop', eqTop)
            }
        }, err => {
            console.log(err)
        })
    }

    // 最近一周内外部人员预约使用情况
    getEqUserAppoint() {
        const that = this;
        let params = {};
        if (that.eqAppointDateRange && that.eqAppointDateRange.length > 0) {
            params = {
                beginTimeString: that.eqAppointDateRange ? that.eqAppointDateRange[0].format(dateFormat) : '',
                endTimeString: that.eqAppointDateRange ? that.eqAppointDateRange[1].format(dateFormat) : ''
            };
        }
        console.log(params)
        getStEqAppointOut(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                that.setValue('eqAppointEchartsFlag', true);
                // if(!eqAppoint_cavans){
                eqAppoint_cavans = echarts.init(document.getElementById('eqUserAppoint'));
                // };
                that.getStEqAppointTop(params);
                that.eqUserAppointEcharts(res)
            } else {
                that.setValue('eqAppointEchartsFlag', false)
                eqAppointEchartsFlag = false
            }
        }, err => {
            console.log(err)
            that.setValue('eqAppointEchartsFlag', false)
        })
    }

    // 最近一周内外部人员预约使用情况图表
    eqUserAppointEcharts(values) {
        const that = this;
        eqAppoint_cavans.clear();
        eqAppoint_cavans.showLoading();
        eqAppoint_cavans.setOption({
            title: {
                text: (values.beginTimeString && values.endTimeString) ? '' + values.beginTimeString + '~ ' + values.endTimeString + '内外部人员预约情况' : '最近一周内外部人员预约情况',
                bottom: 0,
                left: 'center',
                textStyle: {
                    color: '#666',
                    fontSize: 13
                }
            },
            grid: {
                left: '16%',
                right: '16%',
                bottom: 40,
                containLabel: true
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: '{b0}: {c0}次'
            },
            xAxis: {
                type: 'category',
                data: ['外部人员预约数', '内部人员预约数']
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: [values.beNum1, values.beNum2],
                type: 'bar',
                barWidth: '64',
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
            }]
        });
        eqAppoint_cavans.hideLoading()
    }

    // 人员预约次数前十
    getStEqAppointTop(params) {
        const that = this;
        let useTop = this.state.useTop;
        getStEqAppointTop(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                useTop[0].list = res.beList ? res.beList : [];
                useTop[1].list = res.useList ? res.useList : [];
                that.setValue('useTop', useTop)
            }
        }, err => {
            console.log(err)
        })
    }

    // TOP10使用时长
    getStEqUseTimeTop() {
        const that = this;
        let params = { eqId: that.state.eqId ? that.state.eqId : '' };
        if (that.eqTimeDateRange && that.eqTimeDateRange.length > 0) {
            params = Object.assign({}, params, {
                beginTimeString: that.eqTimeDateRange ? that.eqTimeDateRange[0].format(dateFormat) : '',
                endTimeString: that.eqTimeDateRange ? that.eqTimeDateRange[1].format(dateFormat) : ''
            })
        }
        getStEqUseTimeTop(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {

                that.setValue('nUsereqList', res.nList ? res.nList : [])
                that.setValue('wUsereqList', res.wList ? res.wList : [])
                that.setValue('eqTimestr', res.countNum)
            }
        }, err => {
            console.log(err)
        })
    }

    // 最近一周设备使用情况
    // getEqUseInfo() {
    //     const that = this;
    //     let params = {};
    //     if (that.eqUseDateRange && that.eqUseDateRange.length > 0) {
    //         params = {
    //             beginTimeString: that.eqUseDateRange ? that.eqUseDateRange[0].format(dateFormat) : '',
    //             endTimeString: that.eqUseDateRange ? that.eqUseDateRange[1].format(dateFormat) : ''
    //         };
    //     }
    //     console.log(params)
    //     getStEqUseInfoTop(params, res => {
    //         console.log(res);
    //         if (res.statusCode === 1000) {
    //             that.setValue('eqUseEchartsFlag', true);
    //             // if(!eqUse_cavans){
    //             eqUse_cavans = echarts.init(document.getElementById('eqUseInfo'));
    //             // }
    //             that.eqUseInfoEcharts(res)
    //         } else {
    //             that.setValue('eqUseEchartsFlag', false)
    //             eqUseEchartsFlag = false
    //         }
    //     }, err => {
    //         console.log(err)
    //         that.setValue('eqUseEchartsFlag', false)
    //     })
    // }

    // 最近一周设备使用情况图表
    eqUseInfoEcharts(values) {
        const that = this;
        eqUse_cavans.clear();
        eqUse_cavans.showLoading();
        eqUse_cavans.setOption({
            title: {
                text: (values.beginTimeString && values.endTimeString) ? '' + values.beginTimeString + '~ ' + values.endTimeString + '设备使用情况' : '最近一周设备使用情况',
                bottom: 0,
                left: 'center',
                textStyle: {
                    color: '#666',
                    fontSize: 13
                }
            },
            grid: {
                left: '16%',
                right: '16%',
                bottom: 40,
                containLabel: true
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: '{b0}: {c0}'
            },
            xAxis: {
                type: 'category',
                data: ['设备使用时长(H)', '设备使用次数(次)', '故障率(％)']
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: [values.eqUseHour, values.eqUseNum, (values.per * 100).toFixed(1)],
                type: 'bar',
                barWidth: '64',
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
            }]
        });
        eqUse_cavans.hideLoading()
    }

    // 最近一年设备故障率情况
    getEqBadInfoTop() {
        const that = this;
        let eqBadTop = this.state.eqBadTop;
        getStEqBadInfoTop({}, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                eqBadTop[0].per = (res.per * 100).toFixed(1);
                eqBadTop[1].list = res.hPerList ? res.hPerList : [];
                eqBadTop[2].list = res.lPerList ? res.lPerList : [];
                that.setValue('eqBadTop', eqBadTop)
            }
        }, err => {
            console.log(err)
        })
    }

    // 人员信用情况情况
    getUserCreditInfo() {
        const that = this;
        let userCreditTop = this.state.userCreditTop;
        getStUserCreditInfo({}, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                userCreditTop[0].per = res.creditValue;
                userCreditTop[1].list = res.hcreditList ? res.hcreditList : [];
                userCreditTop[2].list = res.lcreditList ? res.lcreditList : [];
                that.setValue('userCreditTop', userCreditTop)
            }
        }, err => {
            console.log(err)
        })
    }

    // PI组信用排名
    getPiCreditInfo() {
        const that = this;
        getStPiCreditInfo({}, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                that.setValue('piCreditList', res.piList ? res.piList : [])
            }
        }, err => {
            console.log(err)
        })
    }

    handelChange1(e) {
        this.setState({
            personName: e.target.value
        })
    }
    handelChange2(e) {
        this.setState({
            workplace: e.target.value
        })
    }
    handelChange3(e) {
        this.setState({
            piName: e.target.value
        })
    }
    handelChange4(e) {
        console.log(e);
        this.setState({
            //默认值改变
            personTypeName: e
        })
    }

    // 设备使用费用
    getUsingPrince() {
        const that = this;
        console.log(that.princeDateRange);
        let params = {
            personType: that.state.personTypeName,
            // document.getElementById("personTypeName").value,
            piName: that.state.piName,
            workplace: that.state.workplace,
            personName: that.state.personName,
            getNum: that.state.getNum,
            pageNo: that.state.pageNo,
            beginTimeString: that.princeDateRange ? that.princeDateRange[0].format(dateFormat) : '',
            endTimeString: that.princeDateRange ? that.princeDateRange[1].format(dateFormat) : ''
        };
        console.log(params)
        getUsingPrince(params, res => {
            console.log(res);
            if (res.statusCode === 1000) {
                that.setValue('usingPrinceList', res.eqRentalList ? res.eqRentalList : []);
                that.setValue('usingPrice_count', res.count ? res.count : 0);

            }
        }, err => {
            console.log(err)
        })
    }

    changeNum(page, pageSize, type) {
        console.log(page, pageSize);
        this.setState({
            pageNo: page
        }, () => {
            this.getUsingPrince();
        })
    }

    changePageSize(current, size, type) {
        this.setState({
            getNum: size
        }, () => {
            console.log(this.state.getNum) // 结果是 100            
            this.getUsingPrince();
        })
        // this.setValue('getNum',size ? size : 10);
        console.log(this.state.getNum);
    }

    setValue(feild, value) {
        this.setState({
            [feild]: value
        })
        // console.log(this.state.pageNo);
        // console.log(this.state.getNum);
    }






    render() {
        const that = this;
        const { eqTop, useTop, eqTimestr, userUseTop, eqBadTop, userCreditTop, eqEchartsFlag, repairEchartsFlag, eqAppointEchartsFlag, eqUseEchartsFlag, piCreditList, PiCredit_loading, PiCredit_pagination, usingPrinceList, usingPrice_count, getNum, pageNo, eqList, piList, nUsereqList, nUsereq_loading, nUsereq_pagination, wUsereqList, wUsereq_loading, wUsereq_pagination } = this.state;
        const PiCredit_columns = [
            {
                title: 'PI组名',
                dataIndex: 'name',
                align: 'center'
            }, {
                title: '信用积分',
                dataIndex: 'value',
                align: 'center'
            }, {
                title: '排名',
                dataIndex: 'orderNum',
                align: 'center'
            }
        ]
        const nUsereq_columns = [
            {
                title: '姓名',
                dataIndex: 'userName',
                align: 'center',
                sorter: (a, b) => {
                    var stringA = a.um.toUpperCase(); // ignore upper and lowercase
                    var stringB = b.um.toUpperCase(); // ignore upper and lowercase
                    if (stringA < stringB) {
                        return -1;
                    }
                    if (stringA > stringB) {
                        return 1;
                    }
                }
            }, {
                title: '使用时长',
                dataIndex: 'userNum',
                align: 'center',
                sorter: (a, b) => a.userNum - b.userNum
            }, {
                title: '次数',
                dataIndex: 'useNum',
                align: 'center',
                sorter: (a, b) => a.useNum - b.useNum
            }, {
                title: '所属课题组',
                dataIndex: 'piName',
                align: 'center'
            }
        ]
        const wUsereq_columns = [
            {
                title: '姓名',
                dataIndex: 'userName',
                align: 'center',
                sorter: (a, b) => {
                    var stringA = a.um.toUpperCase(); // ignore upper and lowercase
                    var stringB = b.um.toUpperCase(); // ignore upper and lowercase
                    if (stringA < stringB) {
                        return -1;
                    }
                    if (stringA > stringB) {
                        return 1;
                    }
                }
            }, {
                title: '使用时长',
                dataIndex: 'userNum',
                align: 'center',
                sorter: (a, b) => a.userNum - b.userNum
            }, {
                title: '次数',
                dataIndex: 'useNum',
                align: 'center',
                sorter: (a, b) => a.useNum - b.useNum
            }, {
                title: '所属课题组',
                dataIndex: 'piName',
                align: 'center'
            }
        ]
        const usingPrince_columns = [
            {
                title: '姓名',
                dataIndex: 'personName',
                align: 'center',
                width: '10%'
            }, {
                title: '设备',
                dataIndex: 'eqName',
                align: 'center',
                width: '10%'
            }, {
                title: '单位',
                dataIndex: 'workplace',
                align: 'center',
                width: '10%'
            }, {
                title: '课题组',
                dataIndex: 'piName',
                align: 'center',
                width: '10%'
            }, {
                title: '人员类型',
                dataIndex: 'personTypeName',
                align: 'center',
                width: '10%'
            }, {
                title: '时长（h）',
                dataIndex: 'usingTime',
                align: 'center',
                width: '10%'
            }, {
                title: '单价（元/h）',
                dataIndex: 'usingPrice',
                align: 'center',
                width: '10%'
            }, {
                title: '合计（元）',
                dataIndex: 'usingRental',
                align: 'center',
                width: '12%'
            }
        ]

        const eqUseList_columns = [
            {
                title: '名称',
                dataIndex: 'NAME',
                align: 'center',
                width: '20%'
            },
            {
                title: '预约次数',
                dataIndex: 'orderNum',
                align: 'center',
                sorter: (a, b) => a.orderNum - b.orderNum,
                width: '20%'
            }, {
                title: '使用次数',
                dataIndex: 'useNum',
                align: 'center',
                sorter: (a, b) => a.useNum - b.useNum,
                width: '20%'
            }, {
                title: '使用时长',
                dataIndex: 'useTimeNum',
                align: 'center',
                sorter: (a, b) => a.useTimeNum - b.useTimeNum,
                width: '20%'
            }, {
                title: '故障次数',
                dataIndex: 'faultNum',
                align: 'center',
                sorter: (a, b) => a.faultNum - b.faultNum,
                width: '20%'
            }
        ]
        //复选框
        const selectedRowsgetNum = [];
        const table_rowSelection = {
            onSelect: (record, selected, selectedRows) => {
                that.setState({
                    selectData: selectedRows
                })
                console.log(this.state.selectData)
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
                that.setState({
                    selectData: selectedRows
                })
                console.log(this.state.selectData)
            },
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(this.id)
                console.log(selectedRowKeys)
                if (selectedRows.length > 0) {
                    for (var i = 0; i < selectedRows.length; i++) {
                        selectedRowsgetNum.push(selectedRows[i].getNum);
                    }
                }
                console.log(selectedRowsgetNum)
                that.setState({ selectedRowKeys });
                that.setState({ selectedRowsgetNum });
            }
        }
        //复选框type=3
        const selectedRowsgetNum3 = [];
        const table_rowSelection3 = {
            onSelect: (record, selected, selectedRows) => {
                that.setState({
                    selectData3: selectedRows
                })
                console.log(this.state.selectData3)
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
                that.setState({
                    selectData3: selectedRows
                })
                console.log(this.state.selectData3)
            },
            onChange: (selectedRowKeys3, selectedRows3) => {
                console.log(this.id)
                console.log(selectedRowKeys3)
                if (selectedRows3.length > 0) {
                    for (var i = 0; i < selectedRows3.length; i++) {
                        selectedRowsgetNum3.push(selectedRows3[i].getNum);
                    }
                }
                console.log(selectedRowsgetNum3)
                that.setState({ selectedRowKeys3 });
                that.setState({ selectedRowsgetNum3 });
            }
        }
        const paginationProps = {
            showSizeChanger: false,
            showQuickJumper: false,
            total: usingPrice_count,
            pageSize: getNum,
            current: pageNo,
            defaultPageSize: getNum,
            showTotal: () => `共'${usingPrice_count}'条`,
            onShowSizeChange: this.changePageSize,
            onChange: this.changeNum,

        }

        return (
            <div key='statistic' className="statistic">
                <div key='main_con' className="main_con">
                    <Card title={<Text strong style={{fontSize:'15px'}}><i className="iconfont icon-xianweijing1-copy c_8bff mr5 vm f20"></i>课题组设备使用时长和次数统计</Text>} className={`${styles.statistic_panel} statistic_panel`}>
                        <div className="tc">
                            <Select
                                showSearch
                                placeholder="选择课题组"
                                className="inlineBlock mr10"
                                style={{ minWidth: '100px' }}
                                optionFilterProp="children"
                                onChange={(value, option) => this.eqInfopiIdSelect(value, option)}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                            >
                                {piList.map(x => {
                                    return (
                                        <Option value={x.id.toString()} key={x.id} title={x.name}>
                                            {x.name}
                                        </Option>
                                    )
                                })}
                            </Select>
                            {/* <Select
                                showSearch
                                placeholder="选择设备"
                                className="inlineBlock mr10"
                                style={{ minWidth: '50px' }}
                                optionFilterProp="children"
                                onChange={(value, option) => this.eqInfoeqIdSelect(value, option)}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                            >
                                {eqList.map(x => {
                                    return (
                                        <Option value={x.id.toString()} key={x.id} title={x.name}>
                                            {x.name}
                                        </Option>
                                    )
                                })}
                            </Select> */}
                            <RangePicker
                                // size='small'
                                style={{width:'223px'}}
                                format={dateFormat}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                onChange={(dates) => {
                                    that.eqInfoDateRange = dates;
                                }}
                            />
                            <Button className="ml10" onClick={this.getEqInfo}>查询</Button>
                        </div>
                        {eqEchartsFlag ? <div className={styles.barChartsBox} id="eqInfo"></div> : <Empty className={styles.echarts_empty} />}
                        {/* <List
                            grid={{ gutter: 32, column: 2 }}
                            dataSource={eqTop}
                            renderItem={item => (
                                <List.Item>
                                    <Card
                                        title={<span><Icon type="trophy" className="c_run" />{item.title}</span>}
                                        hoverable={true}
                                    >
                                        {item.list.length > 0 ?
                                            <ul>
                                                {item.list.map(x => {
                                                    return (
                                                        <li className={styles.cardLi} key={x.id}><span className="mr10" style={{ flex: 1, fontSize: '13.6px' }}>{x.name}</span><small style={{ width: '48px' }}>{x.value}</small></li>
                                                    )
                                                })}
                                            </ul>
                                            :
                                            <Empty />
                                        }
                                    </Card>
                                </List.Item>
                            )}
                            className={`${styles.statistic_ListCard} statistic_ListCard`}
                        /> */}
                    </Card>
                </div>
            </div>
        )
    }
}


export default Statistic;

